import styled from 'styled-components';

export const JobNameField = styled.div`
  .job-name {
    color: var(--color-text);
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;
    margin: 10px 0 0;

    a {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 130%;
      color: var(--color-text);
    }
  }

  .id-field {
    margin: 0 0 10px;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 160%;
    color: #b4b9d9;
  }
`;
